import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";

import {
  sendMessageToGroup,
  clearAdminMessageState,
} from "../redux/slices/adminMessageSlice";

const AdminMessages = () => {

  const dispatch = useDispatch();

  const {
    sending,
    error,
    successMessage,
  } = useSelector((state) => state.adminMessages);

  const [form, setForm] = useState({
    title: "",
    description: "",
    type: "admin_message",
    target: "both",
  });

  // --------------------------------
  // Listen for success or error
  // --------------------------------
  useEffect(() => {
    if (successMessage) {
      Swal.fire("Success", successMessage, "success");
      dispatch(clearAdminMessageState());

      setForm({
        title: "",
        description: "",
        type: "admin_message",
        target: "user",
      });
    }

    if (error) {
      Swal.fire("Error", error, "error");
      dispatch(clearAdminMessageState());
    }
  }, [successMessage, error]);

  // --------------------------------
  // Send Message Only
  // --------------------------------
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(sendMessageToGroup(form));
  };

  return (
    <div className="container py-4">
      <div className="row justify-content-center">

        <div className="col-md-6">
          <div className="card">

            <div className="card-header">
              <h4 className="mb-3">Send Message Notification</h4>
            </div>

            <div className="card-body">

              <form onSubmit={handleSubmit}>

                <div className="mb-3">
                  <label>Title</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    value={form.title}
                    onChange={(e) => setForm({ ...form, title: e.target.value })}
                  />
                </div>

                <div className="mb-3">
                  <label>Description</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    required
                    value={form.description}
                    onChange={(e) => setForm({ ...form, description: e.target.value })}
                  />
                </div>

                {/* <div className="mb-3">
                  <label>Send To (Target)</label>
                  <select
                    className="form-control"
                    value={form.target}
                    onChange={(e) => setForm({ ...form, target: e.target.value })}
                  >
                    <option value="user">User</option>
                    <option value="servicemen">Servicemen</option>
                    <option value="both">Both</option>
                  </select>
                </div> */}

                <button
                  type="submit"
                  className="btn btn-success w-100"
                  disabled={sending}
                >
                  {sending ? "Sending..." : "Send Message"}
                </button>

              </form>

            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AdminMessages;
